import { useTranslation } from 'react-i18next'

/** Shared inline feedback for both the pull gesture and the desktop button. */
export function RefreshStatus({ visible }: { visible: boolean }) {
  const { t } = useTranslation()
  if (!visible) return null
  return (
    <p
      className="mt-3 inline-flex items-center gap-2 text-sm font-semibold text-muted"
      role="status"
      aria-live="polite"
    >
      <span className="spinner size-4" aria-hidden="true" />
      {t('discovery.refreshing')}
    </p>
  )
}
